export function createHeatmapsFilters(): FilterProperties[] {
  return [
    { label: 'KVSName', property: 'kvsName', type: 'string' },
    { label: 'Timestamp', property: 'timestamp', type: 'date' },
  ];
}
